import React from 'react';
import { capturePortalError } from '../lib/portalErrorReporting';
import { isStaleChunkLoadError } from '../lib/staleChunkRecovery';

/**
 * Decorative artwork must never unmount the operational page or its drafts. A test layout's page features
 * (`layout_feature`, docs/test-layouts.md) are optional the same way: a failure renders nothing.
 */
export default class OptionalDecorationBoundary extends React.Component<{
  children: React.ReactNode;
  decoration: 'holiday_topbar' | 'holiday_logo' | 'layout_feature';
  /** For `layout_feature`: which page feature failed. */
  feature?: string;
}, { failed: boolean }> {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    const assetFailure = isStaleChunkLoadError(error);
    void capturePortalError({
      source: 'react_error_boundary', error, componentStack: info.componentStack || '',
      operation: 'load_optional_decoration',
      classification: assetFailure ? 'connectivity' : 'portal_defect',
      severity: assetFailure ? 'warning' : 'error',
      context: { decoration: this.props.decoration, ...(this.props.feature ? { feature: this.props.feature } : {}) },
    });
  }

  render() {
    return this.state.failed ? null : this.props.children;
  }
}
